// extracted by mini-css-extract-plugin
export default {"bar":"BudgetTabs_bar__OPsyE","year":"BudgetTabs_year__o-iE4","tabs":"BudgetTabs_tabs__H+PMy"};